import { InjectedOptions, useMutation } from "@oysterhr/core"

import { gql } from "../gql"
import {
  OysterIntelligenceCustomerSubscribeSalaryInsightsTrialMutation,
  OysterIntelligenceCustomerSubscribeSalaryInsightsTrialMutationVariables,
} from "../gql/graphql"
import { OYSTER_INTELLIGENCE_CUSTOMER_GET_PLANS_AND_PERMISSIONS } from "@oysterhr/cost-calculator"

const OYSTER_INTELLIGENCE_CUSTOMER_SUBSCRIBE_SALARY_INSIGHTS_TRIAL = gql(`
  mutation OysterIntelligenceCustomerSubscribeSalaryInsightsTrial($input: AddOnSubscribeInput!) {
    addOnSubscribe(input: $input) {
      errors
      addOn {
        id
      }
    }
  }
`)

export function useSalaryInsightsSubscribeToTrialMutation(
  options?: InjectedOptions<
    OysterIntelligenceCustomerSubscribeSalaryInsightsTrialMutation,
    OysterIntelligenceCustomerSubscribeSalaryInsightsTrialMutationVariables
  >,
) {
  return useMutation(OYSTER_INTELLIGENCE_CUSTOMER_SUBSCRIBE_SALARY_INSIGHTS_TRIAL, {
    ...options,
    refetchQueries: [OYSTER_INTELLIGENCE_CUSTOMER_GET_PLANS_AND_PERMISSIONS],
  })
}
